import { ComponentProps, PropsWithChildren } from "react";

import { cn } from "@bentolabs/kit/utils";

export const SocialLink = ({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<"a">>) => {
  return (
    <a
      className={cn(
        "text-nobel/50 hover:text-nobel transition-colors",
        className
      )}
      {...props}
    >
      {children}
    </a>
  );
};
